import React from 'react';
import { Button, ProgressBar, SparkIcon, TagFeedback, Text } from '@spark';
import { waitingSentence } from '../utils/busy';

/**
 * Bottom-right card while an update runs (Figma 91:12390), or waits for running work first; the
 * platform is read-only in both. Admins can see what it waits for, and cancel it while it waits.
 */
export default function UpdateInProgressCard({ upgrade, isAdmin, onShowWaitingFor, onCancel }) {
    const draining = upgrade.phase === 'draining';
    const title = draining ? 'Waiting to update' : 'Update in progress';
    return (
        <section className="platform-upgrader-progress" role="status" aria-label={title}>
            {draining ? (
                <SparkIcon slug="clock-hour-icon" size={48} className="platform-upgrader-progress-icon" />
            ) : (
                <SparkIcon slug="refresh" size={48} className="platform-upgrader-progress-icon spark-icon-spin" />
            )}
            <div className="platform-upgrader-progress-body">
                <div className="platform-upgrader-progress-title">
                    <Text as="span" variant="base-semibold" color="primary">
                        {title}
                    </Text>
                    <TagFeedback label="Read only" variant="warning" showIcon />
                </div>
                <Text as="p" variant="base-regular" color="secondary" className="platform-upgrader-paragraph">
                    {draining
                        ? waitingSentence(upgrade.waiting_for)
                        : 'You can browse the platform, but not make changes.'}
                </Text>
                {!draining && <ProgressBar value={upgrade.progress} fill />}
                {draining && isAdmin && (
                    <div className="platform-upgrader-row-actions">
                        <Button variant="ghost" size="small" type="button" onClick={onCancel}>
                            Cancel update
                        </Button>
                        <Button variant="secondary" size="small" type="button" onClick={onShowWaitingFor}>
                            See processes
                        </Button>
                    </div>
                )}
            </div>
        </section>
    );
}
